/* eslint-disable no-empty-pattern */
import apiClient from "@/config/api";
import { getToken, removeToken } from "@/utils/tokenStorage";
const RESOURCE = "/auth";
const RESOURCE_PROFILE = "/users";

const actions = {
  login({ commit }, credentials) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`${RESOURCE}/login`, credentials)
        .then((res) => {
          commit("SET_USER", res.data.user);
          commit("SET_TOKEN", res.data.access_token);
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
          // console.error("API Error:", err);
        })
        .finally(() => {
          // commit("SET_LOADING", false);
        });
    });
  },
  loginWithGoogle({ commit }, googleToken) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`${RESOURCE}/google-login`, { accessToken: googleToken })
        .then((res) => {
          commit("SET_USER", res.data.user);
          commit("SET_TOKEN", res.data.access_token);
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  logout({ commit }) {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    return new Promise((resolve) => {
      apiClient.post(`${RESOURCE}/logout`, {}, config).finally(() => {
        removeToken();
        commit("CLEAR_AUTH_DATA");
        resolve();
      });
    });
  },
  forgotPassword({ commit }, email) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`${RESOURCE}/forgot-password`, email)
        .then((res) => {
          commit("REQUEST_OK", res.data);
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
          // console.error("API Error:", err);
        });
    });
  },
  changePassword({ commit }, data) {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    return new Promise((resolve, reject) => {
      apiClient
        .post(`${RESOURCE_PROFILE}/change-password`, data, config)
        .then((res) => {
          commit("REQUEST_OK", res.data);
          resolve(res);
        })
        .catch((err) => {
          // console.log(err)
          reject(err);
        });
    });
  },
  updateProfile({ commit }, userData) {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    return new Promise((resolve, reject) => {
      apiClient
        .post(`${RESOURCE_PROFILE}/update`, userData, config)
        .then((res) => {
          commit("SET_USER", res.data.data.user);
          resolve(res.data.data.user);
        })
        .catch((err) => {
          reject(err);
          // console.error("API Error:", err);
        });
    });
  },
  getMe({ commit }) {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    return new Promise((resolve, reject) => {
      apiClient
        .get(`${RESOURCE}/me`, config)
        .then((res) => {
          commit("SET_USER", res.data);
          commit("SET_TOKEN", getToken());
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
          // console.error("API Error:", err);
        });
    });
  },
  activateAccount({ commit }, data) {
    const config = {
      headers: {
        Authorization: `Bearer ${data.token}`,
      },
    };
    // console.log(config)
    return new Promise((resolve, reject) => {
      apiClient
        .post(`${RESOURCE_PROFILE}/activate`, { token: data }, config)
        .then((res) => {
          commit("REQUEST_OK", res);
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
          // console.error("API Error:", err);
        });
    });
  },
  autoRegister({}, userData) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`${RESOURCE}/register`, userData)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
          // console.error("API Error:", err);
        });
    });
  },
};

export default actions;
